/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
    'use strict';
    /*globals Tc */

    /**
     * ImageMapItem
     *
     * @author Nikola Lakovic
     * @namespace Tc.Module
     * @class ImageMapItem
     * @extends Tc.Module
     */

    Tc.Module.ImageMapItem = Tc.Module.extend({
        on: function(callback) {
            var $ctx = this.$ctx;
            this.$container = this.$ctx.find('.text-area');
            var $positionEl = this.$container.data('pos');

            if($positionEl) {
                this.$container.css({
                    'position': 'absolute',
                    'left': this.$container.data('left'),
                    'top': this.$container.data('top'),
                    'width': this.$container.data('width'),
                    'height': this.$container.data('height')
                });
            } else {
                this.$container.css('position', 'static');
            }
            callback();
        }
    });
}(Tc.$));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.ImageMapItem.js
// module id = 147
// module chunks = 0